import { render, staticRenderFns } from "./PriTama06.vue?vue&type=template&id=b1d74ef8&scoped=true&"
import script from "./PriTama06.vue?vue&type=script&lang=js&"
export * from "./PriTama06.vue?vue&type=script&lang=js&"
import style0 from "./PriTama06.vue?vue&type=style&index=0&id=b1d74ef8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d74ef8",
  null
  
)

export default component.exports